class ResponseError extends Error {
    response: Response

    constructor(message: string, res: Response) {
        super(message)
        this.response = res
    }
}

export function handleError(err: unknown) {
    // Safe to our choice of logging service
    // saveToALoggingService(err);

    if (err instanceof Error) {
        return err;
    }

    if (typeof err === "string") {
        console.error(err);
        return new Error(err);
    }

    return new Error("Unknown error");

    /* if (err instanceof ResponseError) {
        switch (err.response.status) {
            case 500:
                // Show user a dialog to apologize that we had an error and to 
                // try again and if that doesn't work contact support
                console.error('Server error', { cause: err })
                break;
            default:
                // Show 
                throw new Error('Unhandled fetch response', { cause: err })
        }
    }
    throw new Error('Unknown fetch error', { cause: err }) */
}

export async function fetchJson<T>(url: string, options?: RequestInit) {
    const res = await fetch(url, options)
    if (!res.ok) {
        throw new ResponseError('Bad fetch response', res)
    }
    const json = await res.json()
    return json as T;
}